import { Building2 } from "lucide-react";

export default function SponsorBadge({ sponsor, compact = false }) {
  if (!sponsor || !sponsor.name) return null;
  const Inner = (
    <div
      className={`flex items-center gap-2 ${compact ? "tag" : "border px-3 py-2"}`}
      style={{ borderColor: "rgba(251,191,36,0.4)", background: "rgba(251,191,36,0.06)", color: "#fcd34d" }}
      data-testid="sponsor-badge"
    >
      <Building2 size={compact ? 11 : 14} />
      <span className={compact ? "label-mono" : "text-sm font-medium"}>
        Sponsored · {sponsor.name}
      </span>
    </div>
  );
  if (sponsor.url) {
    return (
      <a href={sponsor.url} target="_blank" rel="noreferrer" className="inline-block hover:opacity-90 transition">
        {Inner}
      </a>
    );
  }
  return Inner;
}
